// used for setting back navigation labels
export default {
  Back: "Back",
  Requests: "Requests",
  PaymentSettings: "Payment Settings",
  GeneralRequest: "Create Request"
};
